import React from 'react';

interface Props {
  icon: string;
  value: number | string;
}

export const GameHeaderCard = (props: Props) => {
  return (
    <div className='game_details_main'>
      <div className='game_details_inner'>
        <span className={'game_details_icon ' + props.icon}></span>
        <span className='game_details_value'>{props.value}</span>
      </div>
    </div>
  );
};
